export const BLOG_CATEGORY_GROUPS = [
  {
    label: "Research & Science",
    color: "#15803d",
    background: "#dcfce7",
    categories: [
      "Agronomy Research",
      "Plant Physiology & Stress Detection",
      "Soil Science & Soil Health",
      "Case Studies & Field Results",
    ],
  },
  {
    label: "Smart Farming & Technology",
    color: "#1d4ed8",
    background: "#dbeafe",
    categories: [
      "Artificial Intelligence in Agriculture",
      "Precision Agriculture",
      "Sensor Technology & IoT",
      "GIS & Geospatial Analysis",
      "Remote Sensing & Satellites",
      "AgriTech Innovations",
    ],
  },
  {
    label: "Farm Management",
    color: "#c2410c",
    background: "#ffedd5",
    categories: [
      "Crop Monitoring & Management",
      "Irrigation & Water Management",
      "Agricultural Data Analytics",
    ],
  },
  {
    label: "Sustainability",
    color: "#7e22ce",
    background: "#f3e8ff",
    categories: ["Sustainability & Climate-Smart Farming"],
  },
  {
    label: "Learning Resources",
    color: "#4b5563",
    background: "#f3f4f6",
    categories: ["Guides", "Tools & Tutorials", "Engineering"],
  },
];

const fallbackStyle = {
  label: "Category",
  color: "#4b5563",
  background: "#f3f4f6",
};

export function getCategoryStyle(categoryName) {
  return (
    BLOG_CATEGORY_GROUPS.find((group) =>
      group.categories.includes(categoryName),
    ) || fallbackStyle
  );
}
